/* ══════════════════════════════════════════════════════════════
   IPO Listed — Recently Listed with Gain/Loss
   ══════════════════════════════════════════════════════════════ */

export interface ListedIPO {
    name: string;
    listDate: string;
    issuePrice: number;
    listPrice: number;
    currentPrice: number;
    listingGain: number;
    currentReturn: number;
}

export function renderIPOListed(container: HTMLElement, ipos?: ListedIPO[]): void {
    const data: ListedIPO[] = ipos || [
        { name: 'Swiggy', listDate: 'Nov 15', issuePrice: 390, listPrice: 412, currentPrice: 450, listingGain: 5.6, currentReturn: 15.4 },
        { name: 'NTPC Green', listDate: 'Dec 2', issuePrice: 108, listPrice: 115, currentPrice: 125, listingGain: 6.5, currentReturn: 15.7 },
        { name: 'Afcons Infra', listDate: 'Jan 10', issuePrice: 463, listPrice: 440, currentPrice: 420, listingGain: -5.0, currentReturn: -9.3 },
        { name: 'Waaree Energies', listDate: 'Oct 28', issuePrice: 1503, listPrice: 2500, currentPrice: 2800, listingGain: 66.3, currentReturn: 86.3 },
    ];

    const rows = data.map(ipo => `
    <tr>
      <td><strong>${ipo.name}</strong><br><small>${ipo.listDate}</small></td>
      <td>₹${ipo.issuePrice}</td>
      <td>₹${ipo.listPrice}</td>
      <td>₹${ipo.currentPrice}</td>
      <td class="${ipo.listingGain >= 0 ? 'up' : 'down'}">${ipo.listingGain >= 0 ? '+' : ''}${ipo.listingGain}%</td>
      <td class="${ipo.currentReturn >= 0 ? 'up' : 'down'}">${ipo.currentReturn >= 0 ? '+' : ''}${ipo.currentReturn}%</td>
    </tr>`).join('');

    container.innerHTML = `
    <div class="ipo-listed glass-card">
      <div class="card-header"><h3>📋 Recently Listed</h3></div>
      <div class="table-responsive">
        <table class="ipo-listed-table">
          <thead><tr><th>Company</th><th>Issue ₹</th><th>List ₹</th><th>CMP ₹</th><th>Listing</th><th>Current</th></tr></thead>
          <tbody>${rows}</tbody>
        </table>
      </div>
    </div>`;
}
